import cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import { formConstants } from '../../../utils/constants/form-constants';
import { isEmpty } from '../../../utils/obj-utils';
import { createDateFromExisting } from '../../../utils/date-utils';

const BallotSummaryDetailsFormData = (
    formData,
    userAccountData
) => {
    function buildBallotSummaryDetailsFormData() {
        const ballotFormData = getBallotSummaryUserDetailsFields();
        return getBallotSummaryUserDetailsFieldsWithDefaultValues(ballotFormData);
    }

    function getBallotSummaryUserDetailsFields() {
        const { requestEmailVerificationActionSuccessText, callBackUrl } = formData;

        formData[formConstants.callBackUrl] = callBackUrl;
        formData[formConstants.ssoDomain] = formData[formConstants.ssoDomain];
        formData[formConstants.actionSuccessText] = requestEmailVerificationActionSuccessText;
        formData[formConstants.emailAddress] = formData[formConstants.emailAddress];
        formData[formConstants.confirmEmailAddress] = formData[formConstants.confirmEmailAddress];
        formData[formConstants.title] = formData[formConstants.title];
        formData[formConstants.firstName] = formData[formConstants.firstName];
        formData[formConstants.lastName] = formData[formConstants.lastName];
        formData[formConstants.dateOfBirth] = formData[formConstants.dateOfBirth];
        formData[formConstants.mainAddressLabel] = formData[formConstants.mainAddressLabel];
        formData[formConstants.country] = formData[formConstants.country];
        formData[formConstants.county] = formData[formConstants.county];
        formData[formConstants.state] = formData[formConstants.state];
        formData[formConstants.addressLine1] = formData[formConstants.addressLine1];
        formData[formConstants.addressLine2] = formData[formConstants.addressLine2];
        formData[formConstants.addressLine3] = formData[formConstants.addressLine3];
        formData[formConstants.city] = formData[formConstants.city];
        formData[formConstants.postcode] = formData[formConstants.postcode];
        formData[formConstants.mobilePhone] = formData[formConstants.mobilePhone];
        formData[formConstants.becomeOneClubMemberInfo] = formData[formConstants.becomeOneClubMemberInfo];
        formData[formConstants.offersDetails] = formData[formConstants.offersDetails];
        formData[formConstants.oneClubTermsAndServices] = formData[formConstants.oneClubTermsAndServices];
      
        return formData;
    }

    function getBallotSummaryUserDetailsFieldsWithDefaultValues(formData) {

        formData[formConstants.emailAddress].defaultValue = userAccountData[formConstants.email];
        formData[formConstants.title].defaultValue = userAccountData[formConstants.title];
        formData[formConstants.firstName].defaultValue = userAccountData[formConstants.firstName];
        formData[formConstants.lastName].defaultValue = userAccountData[formConstants.lastName];

        if (!_isEmpty(userAccountData[formConstants.mobilePhone])) {
            formData[formConstants.mobilePhone].defaultValue = {};

            const userMobilePhone = cloneDeep(userAccountData[formConstants.mobilePhone]);

            const userCountryCodeMobilePhonePrefix = userAccountData[formConstants.countryCodeMobilePhonePrefix];

            const selectedCountry = getSelectedCountry(formData, userCountryCodeMobilePhonePrefix, userMobilePhone);

            formData[formConstants.mobilePhone].defaultValue.selectedCountry = selectedCountry;

            formData[formConstants.mobilePhone].defaultValue.phoneNumber = userMobilePhone.replace(selectedCountry.phonePrefix, '');
        }

        if (userAccountData.dateOfBirth !== undefined) {
            formData[formConstants.dateOfBirth].defaultValue = createDateFromExisting(userAccountData.dateOfBirth);
        }

        let mainAddress = {};
        if (!isEmpty(userAccountData.addresses)) {
            const foundAddress = userAccountData.addresses.find((address) => address.main);
            mainAddress = isEmpty(foundAddress) ? {} : foundAddress;
        }

        formData[formConstants.addressLine1].defaultValue = mainAddress.addressLine1;
        formData[formConstants.addressLine2].defaultValue = mainAddress.addressLine2;
        formData[formConstants.addressLine3].defaultValue = mainAddress.addressLine3;
        formData[formConstants.postcode].defaultValue = mainAddress.postcode;
        formData[formConstants.city].defaultValue = mainAddress.city;
        formData[formConstants.country].defaultValue = mainAddress.country;
        formData[formConstants.county].defaultValue = mainAddress.county;
        formData[formConstants.state].defaultValue = mainAddress.state;

        const optIns = userAccountData[formConstants.optIns];
        formData[formConstants.offersDetails].defaultValue =
        {
            [formConstants.refuseOffers]: !optIns.optedTheOpenOffersByEmail,
            [formConstants.acceptOffers]: optIns.optedPartnerOffersByEmail
        };
        
        return formData;
    }

    return buildBallotSummaryDetailsFormData();
};

function getSelectedCountry(formData, userCountryCodeMobilePhonePrefix, userMobilePhone) {

    let selectedCountry = formData[formConstants.country].options
        .find((country) => !_isEmpty(country.phonePrefix) &&
            country.code === userCountryCodeMobilePhonePrefix);

    if (selectedCountry)
        return selectedCountry;

    selectedCountry = formData[formConstants.country].options
        .find((country) => !_isEmpty(country.phonePrefix) &&
            userMobilePhone.includes(country.phonePrefix));

    return selectedCountry;
}

export default BallotSummaryDetailsFormData;
